export default function normalizeURL(url: string): string {
  let theURL = url.replace(/[\d]{10,}/gi, ":integerId");
  theURL = theURL.replace(
    /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/gi,
    ":uuid"
  );

  return theURL;
}
